import { render, staticRenderFns } from "./Especialidades.vue?vue&type=template&id=17c53184&scoped=true"
import script from "./Especialidades.vue?vue&type=script&lang=js"
export * from "./Especialidades.vue?vue&type=script&lang=js"
import style0 from "./Especialidades.vue?vue&type=style&index=0&id=17c53184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c53184",
  null
  
)

export default component.exports